import { put } from 'helpers/api';
import { buildCustomStage } from 'bundles/apex/pipeline/settings/stages/helpers';

export const UPDATE_STAGES = 'UPDATE_STAGES';
export function updateStages(stages) {
  return {
    type: UPDATE_STAGES,
    stages,
  };
}

export const UPDATE_BROKER_GROSS = 'UPDATE_BROKER_GROSS';
export function updateBrokerGross(brokerGross) {
  return {
    type: UPDATE_BROKER_GROSS,
    brokerGross,
  };
}

export const UPDATE_COLUMNS = 'UPDATE_COLUMNS';
export function updateColumns(columns) {
  return {
    type: 'UPDATE_COLUMNS',
    columns,
  };
}

export const SET_SELECTED_STAGE = 'SELECTED_STAGE';
export function setSelectedStage(stage) {
  return {
    type: SET_SELECTED_STAGE,
    stage,
  };
}

export const SET_SAVING = 'SET_SAVING';
export function setSaving(saving) {
  return {
    type: SET_SAVING,
    saving,
  };
}

export const SET_ERRORS = 'SET_ERRORS';
export function setErrors(errors) {
  return {
    type: SET_ERRORS,
    errors,
  };
}

export function updateSelectedStage(stage) {
  return async (dispatch) => {
    dispatch(setErrors(null));
    dispatch(setSelectedStage(stage));
  };
}

export function saveChanges(stage) {
  return async (dispatch, getState) => {
    dispatch(setSaving(true));
    const { stages, path } = getState();
    const customStages = {};
    const updatedStages = { ...stages, [stage.key]: stage };

    for (const key in updatedStages) {
      const customStage = buildCustomStage(updatedStages[key]);
      if (customStage) {
        customStages[key] = { ...customStage };
      }
    }

    if (stage.backfillCheck) {
      customStages.backfillStage = stage.key;
    }

    try {
      const res = await put(path, customStages);
      dispatch(updateStages(res.stages));
      dispatch(setErrors(null));
      dispatch(setSelectedStage(null));
      if (res.notification?.length > 0) dispatch(setNotification(res.notification));
    } catch (e) {
      const errors = e?.length === 0 ? ['An error occurred while saving changes.'] : e;
      dispatch(setErrors(errors));
    }

    dispatch(setSaving(false));
  };
}

export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export function setNotification(text) {
  return {
    type: SET_NOTIFICATION,
    text,
  };
}

export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION ';
export function clearNotification() {
  return {
    type: CLEAR_NOTIFICATION,
  };
}
